export const styles = {
    fileIcon: {
        color: '#009AD9',
        width: 20,
        height: 20
    }
}